import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";

import { Router } from "react-router-dom";

import history from "./history";

import store from "./store/configureStore";
import * as actions from "./store/actions";

import "./ReactotronConfig";

const token = localStorage.getItem("tokenUser");
if (token) {
  store.dispatch(actions.tryAuthFromStorage());
}

const hostname = window.location.hostname.toLowerCase()

if (hostname.includes('pesquisa-qas.grupodma.com.br')){
  window.url_api = `//${hostname}/api/v1`
}
if (hostname.includes('pesquisa.grupodma.com.br')){
  window.url_api = `//${hostname}/api/v1`
}
if (hostname.includes('localhost')){
  window.url_api = `//${hostname}:9000/v1`
}


if (localStorage.tokenUser) {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.tokenUser}`;
}

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error.response.data.token);
    if (
      error.response.status === 403 &&
      error.response.data.token === "invalid"
    ) {
      localStorage.clear();
      window.location = "/";
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
